var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinanceMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H87.5L100 12.5V100H0V0Z",
    fill: "#6666FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 60H20V20H80V60ZM25 55H75V25H25V55Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 50C48.0222 50 46.0888 49.4135 44.4443 48.3147C42.7998 47.2159 41.5181 45.6541 40.7612 43.8268C40.0043 41.9996 39.8063 39.9889 40.1922 38.0491C40.578 36.1093 41.5304 34.3275 42.9289 32.9289C44.3275 31.5304 46.1093 30.578 48.0491 30.1922C49.9889 29.8063 51.9996 30.0043 53.8268 30.7612C55.6541 31.5181 57.2159 32.7998 58.3147 34.4443C59.4135 36.0888 60 38.0222 60 40C60 42.6522 58.9464 45.1957 57.0711 47.0711C55.1957 48.9464 52.6522 50 50 50ZM50 35C49.0111 35 48.0444 35.2932 47.2222 35.8427C46.3999 36.3921 45.759 37.173 45.3806 38.0866C45.0022 39.0002 44.9032 40.0056 45.0961 40.9755C45.289 41.9454 45.7652 42.8363 46.4645 43.5355C47.1637 44.2348 48.0546 44.711 49.0246 44.9039C49.9945 45.0969 50.9998 44.9978 51.9134 44.6194C52.8271 44.241 53.6079 43.6001 54.1574 42.7779C54.7068 41.9556 55 40.9889 55 40C55 38.6739 54.4732 37.4022 53.5355 36.4645C52.5979 35.5268 51.3261 35 50 35Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70 37.5H65V42.5H70V37.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 37.5H30V42.5H35V37.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65H20V70H80V65Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80 75H20V80H80V75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceMini);
export default __webpack_public_path__ + "static/media/finance_mini.7174c42400d5531cfd81c7b03a2e43a7.svg";
export { ForwardRef as ReactComponent };